<template>
	<article class="winner">
		<EventWinnerPickEventInfo
			v-if="details && !isEmpty(details)"
			ref="EventWinnerPickEventInfo"
			:info="details"
		/>
		<form id="searchfilter" @submit.prevent="searching">
			<EventWinnerPickSearchFilter ref="EventWinnerPickSearchFilter" />
		</form>
		<div class="btn-wrap-main">
			<button
				form="searchfilter"
				type="submit"
				class="btn-main blue"
				v-text="'검색'"
			/>
			<button
				type="button"
				class="btn-main blue bordered"
				v-text="'검색조건 초기화'"
				@click="initFilter"
			/>
		</div>
		<EventWinnerPickAttendeeList
			ref="EventWinnerPickAttendeeList"
			:eventApplyData="eventApplyData"
			:lastListReqUrl="lastAttendeeListReqUrl"
			:totalAttendeeCnt="totalAttendeeCnt"
			:searchAttendeeCnt="searchAttendeeCnt"
			:attendeeList="attendeeList"
			:winnerMappedPdtList="winnerMappedPdtList"
			:idEvent="idEvent"
			:eventTitle="details.eventTitle"
			@checkedList="checkedAttendeeList = [...$event]"
		/>
		<div class="btn-wrap-main">
			<div class="winner__random-selector">
				<InputText
					:propValue="randomSize"
					mode="number"
					nextLabel="명"
					@input="randomSize = $event"
				/>
				<button
					class="btn-main blue"
					v-text="'랜덤 선택'"
					@click="selectWinner(true)"
				/>
			</div>
			<button
				class="btn-main blue bordered winner__add-button"
				@click="selectWinner(false)"
			>
				<i class="fa fa-long-arrow-up winner__add-button__icon" />
				선택 추가 ({{ checkedAttendeeList.length }}명)
			</button>
		</div>
		<EventWinnerPickWinnerList
			:eventApplyData="eventApplyData"
			:lastDetailsReqUrl="lastWinnerDetailsReqUrl"
			:totalWinnerCnt="totalWinnerCnt"
			:idEvent="idEvent"
			:winnerMappedPdtList="winnerMappedPdtList"
			:tabbedPdtId="tabbedPdtId"
			:originWinnerMappedPdtList="originWinnerMappedPdtList"
			:eventTitle="details.eventTitle"
			@tabbedPdtId="tabbedPdtId = $event"
		/>
		<ManagingSection size="l">
			<ManagingBox title="내용">
				<TextCounter
					v-model="winnerDesc"
					:maxLength="1000"
					placeholder="입력하신 내용은 당첨자발표 리스트 상단에 노출 됩니다."
					:useTextarea="true"
				/>
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button
				v-if="isSelectComplete"
				class="btn-main blue bordered"
				v-text="'당첨자 변경 완료'"
				@click="winnerChangeComplete"
			/>
			<template v-else>
				<button
					class="btn-main blue"
					v-text="'임시 저장'"
					@click="winnerTempSave"
				/>
				<button
					:disabled="isBeforeEnd"
					:class="['btn-main', { 'blue bordered': !isBeforeEnd }]"
					v-text="'당첨자 선정 완료'"
					@click="winnerSelectComplete"
				/>
			</template>
		</div>
	</article>
</template>
<script>
	import isEmpty from 'lodash/isEmpty';
	import sampleSize from 'lodash/sampleSize';
	import { findNoUser } from '@/util.js';
	import EventWinnerPickEventInfo from '@/components/event/EventWinnerPickEventInfo.vue';
	import EventWinnerPickSearchFilter from '@/components/event/EventWinnerPickSearchFilter.vue';
	import EventWinnerPickAttendeeList from '@/components/event/EventWinnerPickAttendeeList.vue';
	import InputText from '@/components/InputText';
	import EventWinnerPickWinnerList from '@/components/event/EventWinnerPickWinnerList.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import TextCounter from '@/components/TextCounter.vue';

	export default {
		name: 'EventWinnerPick',
		components: {
			EventWinnerPickEventInfo,
			EventWinnerPickSearchFilter,
			EventWinnerPickAttendeeList,
			InputText,
			EventWinnerPickWinnerList,
			ManagingSection,
			ManagingBox,
			TextCounter,
		},
		data() {
			return {
				isEmpty,
				idEvent: this.$route.params.idEvent,
				details: {},
				eventApplyData: [],
				lastAttendeeListReqUrl: '',
				totalAttendeeCnt: 0,
				searchAttendeeCnt: 0,
				attendeeList: [],
				randomSize: '',
				checkedAttendeeList: [],
				selectedIdList: [],
				lastWinnerDetailsReqUrl: '',
				surveyLink: '',
				isSelectComplete: false,
				totalWinnerCnt: 0,
				winnerMappedPdtList: [],
				tabbedPdtId: null,
				originWinnerMappedPdtList: null,
				winnerDesc: '',
			};
		},
		computed: {
			isBeforeEnd() {
				return this.details.endDate > Math.ceil(Date.now() / 1000);
			},
			isEventType5() {
				return this.details?.eventType === 5;
			},
		},
		async mounted() {
			await this.initData();
		},
		methods: {
			setFilter() {
				this.$refs.EventWinnerPickSearchFilter.setFilter(
					this.$route.query
				);
				const keyIdx =
					this.$refs.EventWinnerPickSearchFilter.keys.findIndex(
						key => key === 'order'
					);
				const order = this.$route.query[keyIdx];
				if (order) this.$refs.EventWinnerPickAttendeeList.order = order;
			},
			attendeeListParams() {
				const params = this.$refs.EventWinnerPickSearchFilter.params();
				params.order = this.$refs.EventWinnerPickAttendeeList.order;
				params.idEvent = this.idEvent;
				return params;
			},
			setAttendeeData(data) {
				this.totalAttendeeCnt = data.totalAttendeeCnt;
				this.searchAttendeeCnt = data.searchAttendeeCnt;
				this.attendeeList = data.attendeeList;
				this.lastAttendeeListReqUrl = data.lastAttendeeListReqUrl;
			},
			setWinnerData(data) {
				this.surveyLink = data.surveyLink;
				this.isSelectComplete = data.isSelectComplete;
				this.totalWinnerCnt = data.totalWinnerCnt;
				this.winnerMappedPdtList = data.winnerMappedPdtList;
				this.tabbedPdtId = data.tabbedPdtId;
				this.originWinnerMappedPdtList = data.originWinnerMappedPdtList;
				this.winnerDesc = data.winnerDesc;
				this.lastWinnerDetailsReqUrl = data.lastWinnerDetailsReqUrl;
			},
			async initData() {
				this.setFilter();

				const [details, attendeeData, winnerData] = await Promise.all([
					this.$store.dispatch(
						'EventWinnerPick/getDetails',
						this.idEvent
					),
					this.$store.dispatch(
						'EventWinnerPick/getAttendeeList',
						this.attendeeListParams()
					),
					this.$store.dispatch(
						'EventWinnerPick/getWinnerDetails',
						this.idEvent
					),
				]);

				this.$store.commit('headerTitle', details.eventTitle);
				this.details = details;
				this.eventApplyData = details.eventApplyData;
				this.setAttendeeData(attendeeData);
				this.setWinnerData(winnerData);
			},
			async searching() {
				const params = this.attendeeListParams();
				this.$refs.EventWinnerPickSearchFilter.setQueryStr(
					params.order
				);
				const data = await this.$store.dispatch(
					'EventWinnerPick/getAttendeeList',
					params
				);
				this.setAttendeeData(data);
			},
			initFilter() {
				this.$refs.EventWinnerPickSearchFilter.init();
				this.$refs.EventWinnerPickAttendeeList.initOrder();
			},
			addWinner(pdtIdList) {
				const attendeeList = this.attendeeList;
				const selectedIdList = this.selectedIdList;
				const selectedLength = selectedIdList.length;
				const winnerMappedPdtList = this.winnerMappedPdtList;

				const pureSelectedLengthList = pdtIdList.map(pdtId => {
					// 저장되지 않은 당첨자도 포함한 당첨자 리스트
					const winnerList =
						winnerMappedPdtList.find(
							item => item.idProduct === pdtId
						)?.candidates || [];

					// 저장된 당첨자 리스트
					const originWinnerList =
						this.originWinnerMappedPdtList.find(
							item => item.idProduct === pdtId
						)?.candidates || [];

					// 당첨자를 제외한 선택된 참여자 리스트
					const pureSelectedAttendeeList = selectedIdList
						.filter(
							selectedId =>
								!winnerList.some(
									item => item.idRegister === selectedId
								)
						)
						.map(selectedId => {
							const item = {
								...attendeeList.find(
									item => item.idRegister === selectedId
								),
								originWinner: originWinnerList.some(
									item => item.idRegister === selectedId
								),
							};
							if (
								item.eventProducts &&
								item.eventProducts.indexOf(String(pdtId)) > -1
							) {
								item.hasReview = true;
							}
							return item;
						});

					this.winnerMappedPdtList = winnerMappedPdtList.map(
						pdtObj => {
							if (pdtObj.idProduct === pdtId) {
								pdtObj.candidates = [
									...pdtObj.candidates,
									...pureSelectedAttendeeList,
								];
								pdtObj.candidateCnt +=
									pureSelectedAttendeeList.length;
								this.totalWinnerCnt +=
									pureSelectedAttendeeList.length;
							}
							return pdtObj;
						}
					);

					return pureSelectedAttendeeList.length;
				});

				const pureSelectedLength = pureSelectedLengthList[0];

				if (
					pdtIdList.length > 1 &&
					pureSelectedLengthList.some(
						length => length !== selectedLength
					)
				) {
					alert(
						'이미 추가되어 있는 참여자는 중복되어 추가되지 않습니다.'
					);
				} else if (
					pdtIdList.length === 1 &&
					selectedLength !== pureSelectedLength
				) {
					alert(
						`이미 추가된 참여자 ${selectedLength - pureSelectedLength}명을 제외한 나머지 ${pureSelectedLength}명을 추가합니다.`
					);
				}

				this.checkedAttendeeList =
					this.$refs.EventWinnerPickAttendeeList.checkedList = [];
			},
			selectWinner(isRandom) {
				const attendeeList = this.attendeeList;
				const randomSize = this.randomSize;
				const checkedAttendeeList = this.checkedAttendeeList;

				if (
					attendeeList.length < 1 || isRandom
						? randomSize < 1
						: checkedAttendeeList.length < 1
				)
					return;

				this.selectedIdList = isRandom
					? sampleSize(attendeeList, randomSize).map(
							item => item.idRegister
						)
					: checkedAttendeeList;

				this.randomSize = '';

				if (this.winnerMappedPdtList.length > 1) {
					this.$store.commit('modal/toggleModal', {
						id: 'SelectProductForEventWinner',
						params: {
							winnerMappedPdtList: this.winnerMappedPdtList,
							addWinner: this.addWinner,
						},
					});
				} else {
					this.addWinner([this.tabbedPdtId]);
				}
			},
			removeWinner({ pdtIdList, removeIdList }) {
				this.winnerMappedPdtList = this.winnerMappedPdtList.map(
					item => {
						if (pdtIdList.some(pdtId => pdtId === item.idProduct)) {
							if (removeIdList.length) {
								this.totalWinnerCnt -= removeIdList.length;
								item.candidateCnt -= removeIdList.length;
								item.candidates = item.candidates.filter(
									winner =>
										!removeIdList.some(
											removeId =>
												removeId === winner.idRegister
										)
								);
							} else {
								this.totalWinnerCnt -= item.candidateCnt;
								item.candidateCnt = 0;
								item.candidates = [];
							}
						}

						return { ...item };
					}
				);
			},
			hasEmptySurveyLink() {
				return this.$refs.EventWinnerPickEventInfo.hasEmptySurveyLink();
			},
			winnerCntInfo() {
				const winnerMappedPdtList = this.winnerMappedPdtList;
				const originWinnerMappedPdtList =
					this.originWinnerMappedPdtList;

				return {
					newCount: findNoUser(
						winnerMappedPdtList,
						originWinnerMappedPdtList
					),
					deleteCount: findNoUser(
						originWinnerMappedPdtList,
						winnerMappedPdtList
					),
				};
			},
			eventProductList() {
				return this.details.eventProductList.map(item => ({
					idProduct: item.idProduct,
					surveyLink:
						this.$refs.EventWinnerPickEventInfo.surveyLinkList[
							item.idProduct
						] || null,
				}));
			},
			winnerCompleteParams(status) {
				const params = {
					idEvent: this.idEvent,
					winnerDescription: this.winnerDesc,
					eventCandidateHistoryTempDTOList:
						this.winnerMappedPdtList.map(item => ({
							idProduct: item.idProduct,
							status,
							idRegister: item.candidates.map(
								userItem => userItem.idRegister
							),
						})),
					eventProductList: this.eventProductList(),
				};

				if (this.surveyLink) params.surveyLink = this.surveyLink;

				return params;
			},
			async winnerComplete() {
				this.$store.dispatch(
					'EventWinnerPick/winnerComplete',
					this.winnerCompleteParams(2)
				);
			},
			winnerChangeComplete() {
				if (this.isEventType5 && this.hasEmptySurveyLink()) return;

				const { newCount, deleteCount } = this.winnerCntInfo();
				let isGood = false;

				if (newCount > 0 && deleteCount > 0) {
					// 새로 추가된 참여자, 삭제된 참여자 모두 있을 경우
					isGood = confirm(
						`참여자 ${newCount + deleteCount}명을 당첨 변경처리하시겠습니까?`
					);
				} else if (newCount > 0 && deleteCount < 1) {
					// 새로 추가된 참여자만 있을 경우
					isGood = confirm(
						`참여자 ${newCount}명을 당첨자 명단에 추가하시겠습니까?`
					);
				} else if (newCount < 1 && deleteCount > 0) {
					// 새로 추가된 참여자만 있을 경우
					isGood = confirm(
						`참여자 ${deleteCount}명을 당첨 취소처리하시겠습니까?`
					);
				}

				if (isGood) {
					this.winnerComplete();
				}
			},
			winnerTempSave() {
				this.$store.dispatch(
					'EventWinnerPick/winnerTempSave',
					this.winnerCompleteParams(1)
				);
			},
			winnerSelectComplete() {
				if (this.isEventType5 && this.hasEmptySurveyLink()) {
					return;
				}

				const noChange = this.winnerMappedPdtList.every(
					item => item.candidates.length < 1
				);

				if (noChange) {
					alert('당첨자로 선택된 참여자가 없습니다.');
					return;
				}

				this.winnerComplete();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.winner__random-selector {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.winner__add-button {
		display: inline-flex;
		margin: 12px 0 0 0;
		align-items: center;
		justify-content: center;
		font-size: 0.875rem;
	}

	.winner__add-button__icon {
		margin: 0 4px 0 0;
		transform: rotate(180deg);
	}

	.winner__survey-link {
		width: 100%;
	}
</style>
